import {useParams} from 'react-router-dom';

import {ModuleEnum, PermissionOperationEnum} from 'src/api/ProactApiClient';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';

import {CourseVideoForm} from 'src/app/course-video/CourseVideoForm';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';

const ViewCourseVideoPage = () => {
  const {courseVideoId, view} = useParams();

  return (
    <ContentWrapper>
      <CourseVideoForm id={+courseVideoId!} mode="view" view={view} />
    </ContentWrapper>
  );
};

routeRegistry.registerPageRoute({
  backNavigation: 'page',
  path: PathUtility.CourseVideoView(':courseVideoId', ':view'),
  element: <ViewCourseVideoPage />,
  module: ModuleEnum.Training,
  operation: PermissionOperationEnum.View,
  isPrivate: true,
});

export default ViewCourseVideoPage;
